import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface UBStore {
    ubid: string;
    setUbid: (ub: string) => void;
    clearUbid: () => void;
}

const useUBStore = create<UBStore>()(
    persist(
        (set) => ({
            ubid: "",
            setUbid: (ubid) => set(() => ({ ubid })),
            clearUbid: () => set(() => ({ ubid: "" })),
        }),
        {
            name: "ubid",
            storage: createJSONStorage(() => sessionStorage),
            skipHydration: true,
        },
    ),
);

export default useUBStore;
